import { render, staticRenderFns } from "./historicalDetailsManagement.vue?vue&type=template&id=f8bb2c02&scoped=true"
import script from "./historicalDetailsManagement.vue?vue&type=script&lang=js"
export * from "./historicalDetailsManagement.vue?vue&type=script&lang=js"
import style0 from "./historicalDetailsManagement.vue?vue&type=style&index=0&id=f8bb2c02&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8bb2c02",
  null
  
)

export default component.exports